import { render, staticRenderFns } from "./ProjectCreate.vue?vue&type=template&id=55da794a&scoped=true&"
import script from "./ProjectCreate.vue?vue&type=script&lang=js&"
export * from "./ProjectCreate.vue?vue&type=script&lang=js&"
import style0 from "./ProjectCreate.vue?vue&type=style&index=0&id=55da794a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55da794a",
  null
  
)

export default component.exports